import { useGlobalStore } from 'src/CrudManager/Core/stores/useGlobalStore'
import { useUserStore } from 'src/CrudManager/Core/stores/useUserStore'
import { type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/auth',
    component: () => import('src/pages/Guests/GuestLayout.vue'),
    beforeEnter: async () => {
      const userStore = useUserStore()
      const globalStore = useGlobalStore()

      if (userStore.loggedIn && userStore.token) {
        return '/'
      }

      await globalStore.resetApp()
      return true
    },
    children: [
      {
        path: '/login',
        component: () => import('src/pages/Guests/LoginPage.vue'),
      },
      {
        path: '/password-reset',
        component: () => import('src/pages/Guests/PasswordResetPage.vue'),
      },
      {
        path: '/forgot',
        component: () => import('src/pages/Guests/ForgotPage.vue'),
      },
    ],
  },
]

export default routes
